import { render, staticRenderFns } from "./serve-call.vue?vue&type=template&id=33932d62"
import script from "./serve-call.vue?vue&type=script&lang=js"
export * from "./serve-call.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33932d62')) {
      api.createRecord('33932d62', component.options)
    } else {
      api.reload('33932d62', component.options)
    }
    module.hot.accept("./serve-call.vue?vue&type=template&id=33932d62", function () {
      api.rerender('33932d62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/physical-model/serve-call.vue"
export default component.exports